function WrenchIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="shrink-0"
    >
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
  );
}

/**
 * Ephemeral indicator shown while the assistant is calling a tool.
 * Displays the latest tool name and is destroyed the moment any
 * non-`tool_use` event arrives from the WebSocket.
 */
export function ToolUseIndicator({ toolName }: { toolName: string }) {
  return (
    <div className="flex items-center gap-2 py-0.5 text-xs text-[var(--color-fg-secondary)] animate-pulse">
      <WrenchIcon />
      <span>
        Use Tool:{" "}
        <span className="font-semibold text-[var(--color-fg)]" style={{ fontFamily: "var(--font-mono)" }}>
          {toolName}
        </span>
      </span>
    </div>
  );
}
